<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted, nextTick, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useNoticeStore } from "@/store/pinia/NoticeModule";
import { initializeComponents } from "@/core/plugins/keenthemes";
import { initTheme } from "@/core/helpers/theme";
import { Mutations, Pages } from "@/store/enums/StoreEnums";
import { useToast } from "vue-toastification";
import PublicError from "@/services/PublicError";

const store = useStore();
const notice = useNoticeStore();
const toast = useToast();

notice.$onAction(({ name: name, after: after }) => {
  after(() => {
    if (name === "setError") {
      const handle = new PublicError(notice.getErrors());

      if (handle.hasError()) {
        toast.error(handle.getErrorText(), {
          timeout: 2000,
        });
      }
    }
  });
});

// Выполняется перед монтированием компонента
onBeforeMount(() => {
  initTheme();
});

// Выполняется после монтирования компонента
onMounted(() => {
  // Коммит для переопределения конфигурации макета
  store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

  // Удаление класса "page-loading" из body после загрузки страницы
  document.body.classList.remove("page-loading");

  nextTick(() => {
    // Инициализация компонентов после удаления класса "page-loading"
    initializeComponents();
  });
});
</script>

<style lang="scss" src="./assets/sass/vue/App.styles.scss"></style>
